import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderStatus from "@/enum/OrderStatus";
import OrderTag from "@/enum/OrderTag";

export function buildOrderStatusIcon(order: OrderDTO) {
    const { status } = order || {};

    if (status === OrderStatus.PENDING_PAYMENT) {
        return <span className="order-status-label label-default">未付款</span>;
    }
    if (status === OrderStatus.PENDING_SHIPMENT) {
        return <span className="order-status-label label-primary">待发货</span>;
    }
    if (status === OrderStatus.SHIPPED) {
        return <span className="order-status-label label-warning">已发货</span>;
    }
    if (status === OrderStatus.SUCCESS) {
        return <span className="order-status-label label-success">已成功</span>;
    }
    if (status === OrderStatus.CANCELED) {
        return <span className="order-status-label label-danger">已取消</span>;
    }
}

const orderTagTbBaseUrl = "https://qw15p3s8hv.feishu.cn/wiki/QUjbwLO6giOvs6kgszQc0o45nPd";
const orderTagPddBaseUrl = "https://qw15p3s8hv.feishu.cn/wiki/YFLHwxGRJiCjHKklvEkctFA1nBe";
const orderTagDouDianKwaiBaseUrl = "https://qw15p3s8hv.feishu.cn/wiki/XJmSwHr56iQ6BekvWd2c43o3nYe";
const orderTagJdBaseUrl = "https://qw15p3s8hv.feishu.cn/wiki/UG4Awq8Xli9umAkNkN4cL5IFn3c";
const orderTagJLBaseUrl = "https://qw15p3s8hv.feishu.cn/wiki/PRTRwdgXJiRyK5ksol3caWNKnds";
const orderTagChannelShopBaseUrl = "https://qw15p3s8hv.feishu.cn/wiki/SnhNwuDcCioh1vk8s3ocyAotnQd";
const orderTagXHSBaseUrl = "https://qw15p3s8hv.feishu.cn/wiki/Gzcgwy0R6iEsP6kecGwc4izpnXb";
const orderTagCommonBaseUrl = "https://qw15p3s8hv.feishu.cn/wiki/DHp1wSM1yiV0kNkuh7McwzTpnOf";
const orderTagManualBaseUrl = "https://qw15p3s8hv.feishu.cn/wiki/BDZiwKjaEi8woyk73KhcHOrKnbg";

export const OrderTagUrl = {
    [OrderTag.ALI_OUT_ORDER_TAOBAO]: `${orderTagTbBaseUrl}#IUT3djDy8o5lQGxUmv7cVhLrnzg`,
    [OrderTag.ALI_OUT_ORDER_PDD]: `${orderTagTbBaseUrl}#IUT3djDy8o5lQGxUmv7cVhLrnzg`,
    [OrderTag.ALI_OUT_ORDER_DY]: `${orderTagTbBaseUrl}#IUT3djDy8o5lQGxUmv7cVhLrnzg`,
    [OrderTag.ALI_OUT_ORDER_KWAI]: `${orderTagTbBaseUrl}#IUT3djDy8o5lQGxUmv7cVhLrnzg`,
    [OrderTag.ALI_OUT_ORDER_XHS]: `${orderTagTbBaseUrl}#IUT3djDy8o5lQGxUmv7cVhLrnzg`,
    [OrderTag.ALI_DELIVERY_GUARANTEE]: `${orderTagTbBaseUrl}#Ktx5d8rCsoJvoCxJ4zccVaP1nGe`,
    [OrderTag.ALI_SEND_ABOUT_TO_OVERDUE]: `${orderTagTbBaseUrl}#XFE9dQ4lAoR4gzxMyhTcklHOnQe`,
    [OrderTag.TMALL_HOME_DELIVERY]: `${orderTagTbBaseUrl}#TkvldaoTZokkuox49jVc9kqTnUg`,
    [OrderTag.TMALL_LOGISTICS_UPGRADE]: `${orderTagTbBaseUrl}#TkvldaoTZokkuox49jVc9kqTnUg`,
    [OrderTag.TMALL_LOGISTICS_SHIP_AS_REQUIRED]: `${orderTagTbBaseUrl}#TkvldaoTZokkuox49jVc9kqTnUg`,
    [OrderTag.TMALL_LOGISTICS_SHIP_BY_SF]: `${orderTagTbBaseUrl}#TkvldaoTZokkuox49jVc9kqTnUg`,
    [OrderTag.TMALL_LOGISTICS_PROMISE_SHIPPING]: `${orderTagTbBaseUrl}#TkvldaoTZokkuox49jVc9kqTnUg`,
    [OrderTag.TMALL_LOGISTICS_PROMISE_SERVED]: `${orderTagTbBaseUrl}#TkvldaoTZokkuox49jVc9kqTnUg`,
    [OrderTag.ALI_SEND_OVERDUE]: `${orderTagTbBaseUrl}#PckPdxOTpotxVjxPxMvcJ9unnAb`,
    [OrderTag.ALI_DELIVER_OVERDUE]: `${orderTagTbBaseUrl}#FvwMd2ZVLozlgwxNiqwcw4RDnPg`,
    [OrderTag.TB_DECORATION_ORDER]: `${orderTagTbBaseUrl}#QyBKdAB6ioKYG8xFoZFcMnVWnfd`,
    [OrderTag.TB_PETTY_FEE_RECEIPT]: `${orderTagTbBaseUrl}#PKuNdWjL2oftZVxhECHcMzcjnld`,
    [OrderTag.ALI_C2M_RESHIPMENT]: `${orderTagTbBaseUrl}#RpX6dxjGFo4zBix0w0ncud9snvg`,
    [OrderTag.ALI_CAN_NOT_SHIP]: `${orderTagTbBaseUrl}#DhhOd80rjoAVJJxewnZcRGe0n6e`,
    [OrderTag.ALI_CUSTOMIZATION]: `${orderTagTbBaseUrl}#RAp7dyhvEokB3UxvAv5coPDJnkd`,
    [OrderTag.TAOTIAN_PAID_FORBIN_CONSIGN]: `${orderTagTbBaseUrl}#OPHvdfIHroGzvVxNQV1cjtqnnUh`,
    [OrderTag.TAOTIAN_SHIP_BY_SF]: `${orderTagTbBaseUrl}#EAhRdyHHuogx57xcaCjcsgOGnOh`,

    [OrderTag.PDD_XINJIANG_CONSOLIDATE]: `${orderTagPddBaseUrl}#WFHOd3I2voCyldxjFEBcX9Bvn8c`,
    [OrderTag.PDD_HK_CONSOLIDATE]: `${orderTagPddBaseUrl}#BiLidSVjvobcPKxCxH3c3ZFgnsQ`,
    [OrderTag.PDD_XIZANG_CONSOLIDATE]: `${orderTagPddBaseUrl}#Z37udyPtwovHJhxXCXpcfshoncb`,
    [OrderTag.PDD_KAZAKHSTAN_CONSOLIDATE]: `${orderTagPddBaseUrl}#AsQhdEMSpolRwGxVm4lcf48enrg`,
    [OrderTag.PDD_JAPAN_CONSOLIDATE]: `${orderTagPddBaseUrl}#SnJGdJKLgoe7RaxfSWpcvhrXnxh`,
    [OrderTag.PDD_TAIWAN_CONSOLIDATE]: `${orderTagPddBaseUrl}#Rd3gdXexIoh94Hxi2wJcoQFWnid`,
    [OrderTag.PDD_KOREA_CONSOLIDATE]: `${orderTagPddBaseUrl}#Yex9dqW1boQlAIxfDiccRZIFnoh`,
    [OrderTag.PDD_SINGAPORE_CONSOLIDATE]: `${orderTagPddBaseUrl}#W1mfdilVso53pdx2u92cxzWpnIf`,
    [OrderTag.PDD_MALAYSIA_CONSOLIDATE]: `${orderTagPddBaseUrl}#R8Zadz3KCowzIgxaHiacObZznJh`,
    [OrderTag.PDD_THAILAND_CONSOLIDATE]: `${orderTagPddBaseUrl}#GW1ndpxlno2lJqxDJCDcEkk2nQb`,
    [OrderTag.PDD_VIETNAM_CONSOLIDATE]: `${orderTagPddBaseUrl}#Vqr5dd2nno9IhbxRbFmclqq7nmf`,
    [OrderTag.PDD_KYRGYZSTAN_CONSOLIDATE]: `${orderTagPddBaseUrl}#PbC1dUhA3o03t3xiL1Ycpx1Enah`,
    [OrderTag.PDD_UZBEKISTAN_CONSOLIDATE]: `${orderTagPddBaseUrl}#KYOFdjfBcodhYQxdc0nco8HPnVc`,
    [OrderTag.SHIP_HOLD]: `${orderTagPddBaseUrl}#MYP7dyHsGoP4Q9xcOYFczsNpnZc`,
    [OrderTag.PDD_SHIP_BY_SF]: `${orderTagPddBaseUrl}#LryKdYqMvoadvpxdVhGc2q8wnxb`,
    [OrderTag.PDD_DESIGNATED_PACKAGE_MATERIAL]: `${orderTagPddBaseUrl}#RxbEddXscobJ8Cx953pcvvy2ncf`,
    [OrderTag.PDD_REGION_BLACK_DELAY_SHIPPING]: `${orderTagPddBaseUrl}#PDGxdR83voeT54xQFZTczp38neh`,
    [OrderTag.PDD_DELIVERY_ONE_DAY]: `${orderTagPddBaseUrl}#I8y4d1Fe0oaz0lx5SfUceystnZr`,
    [OrderTag.PDD_NO_TRACE_DELIVERY]: `${orderTagPddBaseUrl}#Q9FRdWckToWEy6xrgIrcSvdInah`,
    [OrderTag.PDD_COMMUNITY_GROUP]: `${orderTagPddBaseUrl}#SM6edwnXXotPdzxKAF8cgR1bnHc`,
    [OrderTag.PDD_ALLERGY_REFUND]: `${orderTagPddBaseUrl}#RRepd11bKoheeoxWPQ4cNVqZnZe`,
    [OrderTag.PDD_COURIER_DOOR_TO_DOOR_COLLECT]: `${orderTagPddBaseUrl}#QyjhdALI9oPL3Pxuk8xcFaQOnGy`,
    [OrderTag.PDD_HOME_DELIVERY]: `${orderTagPddBaseUrl}#YFLHwxGRJiCjHKklvEkctFA1nBe`,
    [OrderTag.PDD_DIRECT_MAIL_ACTIVITY]: `${orderTagPddBaseUrl}#B1z7ddrhyoXvnKxQiSmc9olqnie`,

    [OrderTag.FULL_PAYMENT_PRESALE]: `${orderTagDouDianKwaiBaseUrl}#KaB9dK3OLowoEMxlw4Tc0q2xnDc`,
    [OrderTag.DOUDIAN_HOME_DELIVERY]: `${orderTagDouDianKwaiBaseUrl}#TFBzdgFl7oDSYIxmrA0ctyVknzJ`,
    [OrderTag.DOUDIAN_HOME_DELIVERY_RECOMMENDED]: `${orderTagDouDianKwaiBaseUrl}#WFnQd9sAOokFb8x87u0cauAjnne`,
    [OrderTag.DOUDIAN_PRIORITY_DELIVERY]: `${orderTagDouDianKwaiBaseUrl}#O5HddsidFoHpQzxO326cFc1lnRh`,
    [OrderTag.DOUBLE_ADDRESS]: `${orderTagDouDianKwaiBaseUrl}#INh9dvtwGo2syxx6zIzclExan2f`,
    [OrderTag.DOUDIAN_REMOTE_DIRECT]: `${orderTagDouDianKwaiBaseUrl}#JJlSdM0rrocpcrx7kXXcPPhpnQh`,
    [OrderTag.DOUDIAN_CONSOLIDATION_XIZANG]: `${orderTagDouDianKwaiBaseUrl}#KKhddX70hoanuix56dHcpZignEY`,
    [OrderTag.KWAI_PRIORITY_DELIVERY]: `${orderTagDouDianKwaiBaseUrl}#FfOodmHmioyO17xyLdNccA3En8c`,
    [OrderTag.DOUDIAN_CONSOLIDATION_XINJIANG]: `${orderTagDouDianKwaiBaseUrl}#DXU0dU4CXo5hQkxoOYpcgtEdnWc`,
    [OrderTag.DOUDIAN_DELIVERY_APPOINTMENT]: `${orderTagDouDianKwaiBaseUrl}#MBtMdjJ6wo4Du7xZEClceBkgn1p`,
    [OrderTag.DOUDIAN_APPOINTMENT_ARRIVAL]: `${orderTagDouDianKwaiBaseUrl}#SBEud5gEvotOgFx7lPoc2UyQnyc`,
    [OrderTag.PERIOD_PURCHASE]: `${orderTagDouDianKwaiBaseUrl}#EFead7YTzoDngjxXhVXcB4LEnfb`,
    [OrderTag.DOUDIAN_CONSOLIDATION_MERGE]: `${orderTagDouDianKwaiBaseUrl}#KtYOdnYzYo9V7lxKv2EclYX0nkd`,
    [OrderTag.KWAI_CONSOLIDATION_XINJIANG]: `${orderTagDouDianKwaiBaseUrl}#XJmSwHr56iQ6BekvWd2c43o3nYe`,
    [OrderTag.KWAI_CONSOLIDATION_NEIMENGGU]: `${orderTagDouDianKwaiBaseUrl}#LYqzdwI3moSYytxucS4czrBRn5d`,
    [OrderTag.KWAI_SHIP_BY_SF]: `${orderTagDouDianKwaiBaseUrl}#OWTkdqjyloEL3mxTOIwcoFwAnC8`,
    [OrderTag.KWAI_SHIP_BY_SF_RECOMMEND]: `${orderTagDouDianKwaiBaseUrl}#MXq4dhprQoBdeBx6aDzc1ARWnTe`,
    [OrderTag.DOUDIAN_HIGH_QUALITY_EXPRESS]: `${orderTagDouDianKwaiBaseUrl}#LW87dROugol7YYxRz5Gc6m9UnBb`,

    [OrderTag.JD_TRY_BEFORE_PAY_LATER]: `${orderTagJdBaseUrl}#LaLodeGA9oMR1BxZt7ecEDisn6d`,
    [OrderTag.JD_PACKING_LIST_REQUIRED]: `${orderTagJdBaseUrl}#U94GdzM1vo7QXyxd3GTclQqRnSh`,
    [OrderTag.JD_FULFILLMENT]: `${orderTagJdBaseUrl}#HaRHdSNERov3kUxkWnQcEt7bnUg`,
    [OrderTag.JD_DELIVERY]: `${orderTagJdBaseUrl}#KSSyd7mYvoWhD2x3shOcRJwmnce`,
    [OrderTag.JD_HOME_DELIVERY_BULKY]: `${orderTagJdBaseUrl}#KSoGdF5lkovxi1xGn6McG4Qanjb`,
    [OrderTag.JD_HOME_DELIVERY_LIGHT]: `${orderTagJdBaseUrl}#R5LmdRivkodkKlx1lcLcvXYonCf`,
    [OrderTag.JD_CONSOLIDATION_XINJIANG]: `${orderTagJdBaseUrl}#ENWbdyV2NotQv9xCNCycbAsSnse`,
    [OrderTag.JD_HYPERLINK_ORDER]: `${orderTagJdBaseUrl}#DkeTdKifeoOGikxUqUzcSdEbnKh`,
    [OrderTag.JD_HYPERLINK_SUBSIDY_ORDER]: `${orderTagJdBaseUrl}#XMv8d8IDZoeW63xWkUAcVU9snCb`,

    [OrderTag.CONSOLIDATED_SHIPPING]: `${orderTagCommonBaseUrl}#Iuydd5aqZoa35ixN28wcQAYFnid`,
    [OrderTag.PRESALE]: `${orderTagCommonBaseUrl}#LbcLdLBiho9HrpxJmE0cOh95nYd`,
    [OrderTag.FREE_SF]: `${orderTagCommonBaseUrl}#LC90d6gG3otJI0x1qLFcDyionjh`,
    [OrderTag.SELF_CONTAINED]: `${orderTagCommonBaseUrl}#BxHEdq8BHoXN2qxhuR2cFwEVnXs`,
    [OrderTag.EXPEDITE_DELIVERY]: `${orderTagCommonBaseUrl}#HuMjdjaH1oJPk5xYqFIchkNKngg`,
    [OrderTag.SHIPPING_DELAY]: `${orderTagCommonBaseUrl}#F6G2dDyRsoRU2qxAdeTcFtRqnob`,
    [OrderTag.ORDER_ITEM_PART_QUANTITY_CANCELED]: `${orderTagCommonBaseUrl}#HXdddILKaosdOHxRCDCcRXyRnmb`,
    [OrderTag.ORDER_ITEM_PART_QUANTITY_SHIPPED]: `${orderTagCommonBaseUrl}#KtPydue35oZkzqxMaZNcuyRjnkL`,
    [OrderTag.LOCKED]: `${orderTagCommonBaseUrl}#PWsjdNLkVo7lPOxA6jocH5WDnsS`,
    [OrderTag.ABNORMAL_ORDER]: `${orderTagCommonBaseUrl}#GV6AdebpToGArkxmhWMcOqzQn4g`,
    [OrderTag.SAMPLE]: `${orderTagCommonBaseUrl}#M9AAdSSg1ocr9xx5kgDcE7oAnRh`,

    [OrderTag.JL_OUT_ORDER_CHANNELSHOP]: `${orderTagJLBaseUrl}#Devhd53rEoYA7zxchBVcWwkznOQ`,

    [OrderTag.CHANNELSHOP_QUALITY_INSPECTION]: `${orderTagChannelShopBaseUrl}#JsTBdZojmo5VsWxkbZncUTnKn3g`,

    [OrderTag.XHS_HOME_DELIVERY]: `${orderTagXHSBaseUrl}#SMQkdCiZko8zfwxZeUzcZLrxnTc`,

    [OrderTag.ENCRYPTED_MANUAL_ORDER_DOUDIAN]: `${orderTagManualBaseUrl}#Wm2AdrVYOoBbXwxlWG4c3PiunCc`,
    [OrderTag.ENCRYPTED_MANUAL_ORDER_TAOBAO]: `${orderTagManualBaseUrl}#LX06dKsVMoLqC5x0fIPctVj7nlg`,
    [OrderTag.ENCRYPTED_MANUAL_ORDER_PDD]: `${orderTagManualBaseUrl}#Z488dOKKKot71GxkE1ucu9awnce`,
    [OrderTag.ENCRYPTED_MANUAL_ORDER_KWAI]: `${orderTagManualBaseUrl}#Z488dOKKKot71GxkE1ucu9awnce`,
    [OrderTag.ENCRYPTED_MANUAL_ORDER_JD]: `${orderTagManualBaseUrl}#Z488dOKKKot71GxkE1ucu9awnce`,
    [OrderTag.ORDER_ITEM_PART_BUNDLE_SKU_SHIPPED]: `${orderTagDouDianKwaiBaseUrl}#HnzGdPzZ0oCgkgx44NUcZ5KLnqf`,
};
